import { Link, NavLink, Outlet } from 'react-router';

import { useAuth } from '../contexts/AuthContext';
import { ThemeToggle } from './ThemeToggle';

/** Cabecalho e navegacao das telas autenticadas. */
export function AppLayout() {
  const { user, logout } = useAuth();

  if (!user) return null;

  const isProfessor = user.role === 'PROFESSOR';

  return (
    <div className="app-shell">
      <header className="app-header">
        <div>
          <p className="eyebrow">Gestão de Processos</p>
          <Link to="/" className="app-title">
            {user.name}
          </Link>
        </div>

        <div className="app-header-side">
          <span className={`badge badge-${isProfessor ? 'professor' : 'student'}`}>
            {isProfessor ? 'Professor' : 'Aluno'}
          </span>
          <ThemeToggle />
          <button type="button" onClick={() => void logout()}>
            Sair
          </button>
        </div>
      </header>

      <nav className="app-nav">
        <NavLink to="/" end>
          Início
        </NavLink>
        <NavLink to="/turmas">Turmas</NavLink>
        {/*
          O PRD secao 20 descreve Meus Fluxos como area do aluno, mas o
          professor tambem precisa rascunhar exemplos para a aula — e o espaco
          e estritamente pessoal, sem exposicao de dado algum. Deixar visivel
          para os dois evita a incoerencia de esconder do menu algo que a URL
          alcanca de qualquer jeito.
        */}
        <NavLink to="/meus-fluxos">Meus Fluxos</NavLink>
        {isProfessor && <NavLink to="/backup">Backup</NavLink>}
        {isProfessor && <NavLink to="/acesso">Acesso</NavLink>}
        <NavLink to="/conta">Conta</NavLink>
      </nav>

      <Outlet />
    </div>
  );
}
